export enum ExportStatus {
    Gestartet = 10,
    DateiErzeugt = 20,
    Upload = 30,
    Fertig = 40,
}

export default class ImpfDbLog {
    public id: number | null = null;
    public zeitraumvon: string | null = null;
    public zeitraumbis: string | null = null;
    public zeitpunkt: string | null = null;
    public anzahldatensaetze: number | null = null;
    public status: ExportStatus | null = null;
    public impfstelle_id: number | null = null;

    public get statusDisplay(): string {
        switch (this.status) {
            case ExportStatus.Gestartet:
                return 'Gestartet';
            case ExportStatus.DateiErzeugt:
                return 'Datei erzeugt';
            case ExportStatus.Upload:
                return 'Upload';
            case ExportStatus.Fertig:
                return 'Fertig';
            default:
                return '';
        }
    }

    constructor(data?: Partial<ImpfDbLog>) {
        Object.assign(this, data);
    }
}
